import {authReducer} from './authReducer';
import {combineReducers} from '@reduxjs/toolkit'
import {reducer as notifications} from 'react-notification-system-redux';
import theme from './themeReducer';


import enums from "./enumsReducers";
import usosMultiples from "./usosMultiplesReducers";
import agentes from "./agentesReducers";
import roles from "./rolesReducers";

import companias from "./companiasReducers";
import clientes from "./clientesReducer";

import dashBoard from "./dashBoardReducers";

import notificaciones from "./notificacionesReducers";

import purchases from "./purchasesReducer";
import pharmacies from "./pharmaciesReducer";
import patients from "./patientsReducer";
import policyExchanges from "./policyExchangeReducers";
import products from "./productReducers";
import categories from "./categoryReducers";
import cities from "./cityReducers";
import countries from "./countryReducers";
import medicalSpecialities from "./medicalSpecialityReducers";
import exchanges from "./exchangeReducers";

const combinedReducer = combineReducers({
    auth: authReducer,
    theme,
    agentes,
    purchases,
    pharmacies,
    patients,
    exchanges,
    policyExchanges,
    products,
    categories,
    roles,
    usosMultiples,
    countries,
    medicalSpecialities,
    cities,
    companias,
    enums,
    clientes,
    dashBoard,
    notificaciones,

    notifications
})

const rootReducer = (state:any, action:any) => {
    if (action.type === 'authReducer/userLogout') {
        state = undefined
    }
    return combinedReducer(state, action)
}

export type AppState = ReturnType<typeof rootReducer>

export default rootReducer
